// Override template with same path as core template
import './transfers.html'

// Override parts of route by exporting a route with the same name
import { route } from 'tmr/routes/report/transfers/transfers'

route.resourceList.searchParameters.push('item.huCodeHistory', 'item.itemIdentifiersHistory', 'item.description', 'propellantVariation.from', 'propellantVariation.to', 'propellant', "item.material", "consignment", "movement.type");
